<template>
  <div class="whole">
    <div class="breadcrumbs flex ai">
      <div class="breadcrumbs-txt default">主页</div>
    </div>
    <div class="main-content flex column jcs">
      <div>
        <!-- <el-carousel height="490px" :interval="5000" arrow="never">
          <el-carousel-item>
          </el-carousel-item>
        </el-carousel> -->
        <div class="bannerBox flex jcc">
          <div style="width: 1371px">
            <img class="ScienceThatMatters" src="@/assets/home/ScienceThatMatters.png" alt="" />
          </div>
        </div>
        <div class="flex jcc" style="margin-top: 0.5rem; margin-bottom: 0.5rem">
          <div class="productBox flex">
            <img @click="enterProduct('专业营养')" class="product pointer" src="@/assets/home/product1.png" alt="" />
            <img @click="enterProduct('基础营养')" class="product pointer" src="@/assets/home/product2.png" alt="" />
            <img @click="enterProduct('果味营养')" class="product pointer" src="@/assets/home/product3.png" alt="" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import Footer from "../../components/Footer.vue";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
// 进入产品页面
const enterProduct = (type) => {
  router.push({ name: "Product", query: { type: type } });
};
</script>

<style src="./home.css" scoped></style>
